module.exports = __webpack_public_path__ + "img/bg2.934fec22.svg";